import { Box, Paper, Stack } from '@mui/material';

import { WizardPageAction as PageAction } from '../../store/wizard/wizard';
import PagesActionButton from '../PagesActionButton/PagesActionButton';
import ProgressBar from '../ProgressBar/ProgressBar';
import VisibleOnDesktop from '../VisibleOnDesktop/VisibleOnDesktop';
import VisibleOnMobile from '../VisibleOnMobile/VisibleOnMobile';
import { FooterStyles, MarginStyles, PaddingStyles } from './PagesFooter.styles';

type PagesFooterProps = {
    onAction: (action: PageAction) => Promise<boolean>;
    actions: PageAction[];
    currentSection: number;
    numberOfSections: number;
    numberOfPagesInSection: number;
    currentPageInSection: number;
    sectionTitle: string;
};

const PagesFooter = ({
    onAction,
    actions: pageActions,
    currentSection,
    numberOfSections,
    numberOfPagesInSection,
    sectionTitle,
    currentPageInSection,
}: PagesFooterProps) => {
    return (
        <>
            <VisibleOnMobile>
                <Paper sx={FooterStyles} square variant="outlined">
                    <Box sx={PaddingStyles}>
                        {numberOfPagesInSection !== 0 && numberOfSections !== 0 && (
                            <ProgressBar
                                currentPage={currentPageInSection}
                                currentSection={currentSection}
                                totalSections={numberOfSections}
                                totalPagesInASection={numberOfPagesInSection}
                                sectionLabel={sectionTitle}
                            />
                        )}
                        <Stack direction={'row'} spacing={2}>
                            {pageActions.map((action) => (
                                <PagesActionButton key={action} action={action} onAction={onAction} />
                            ))}
                        </Stack>
                    </Box>
                </Paper>
            </VisibleOnMobile>

            <VisibleOnDesktop>
                <Box sx={MarginStyles}>
                    <Stack direction={'row'} spacing={2}>
                        {pageActions.map((action) => (
                            <PagesActionButton key={action} action={action} onAction={onAction} />
                        ))}
                    </Stack>
                </Box>
            </VisibleOnDesktop>
        </>
    );
};

export default PagesFooter;
